import { style } from "@vanilla-extract/css";
import { theme } from "../../theme/css/theme.css";

export const inputList = style({
  gap: theme.spacings.xs,
});
